export interface HomeCategory {
    categoryId: string;
    section: "ELECTRIC_CATEGORIES" | "GRID" | "SHOP_BY_CATEGORIES" | "DEALS";
    name: string;
    image: string;
}

export const homeCategories: HomeCategory[] = [
    {
        categoryId: "gaming_laptops",
        section: "ELECTRIC_CATEGORIES",
        name: "Gaming Laptops",
        image: ""
    },
    {
        categoryId: "mobiles",
        section: "ELECTRIC_CATEGORIES",
        name: "Mobiles",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "GRID",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "GRID",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "GRID",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "SHOP_BY_CATEGORIES",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "SHOP_BY_CATEGORIES",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "SHOP_BY_CATEGORIES",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "DEALS",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "DEALS",
        name: "Men Formal Shoes",
        image: ""
    },
    {
        categoryId: "men_formal_shoes",
        section: "DEALS",
        name: "Men Formal Shoes",
        image: ""
    },
];